<template>
  <v-btn-toggle
    v-model="menuButtonSelected"
    mandatory
    active-class="primary"
    rounded
  >
    <v-btn
      :small="$vuetify.breakpoint.smAndDown"
      height="40"
      value="allocate"
      :class="menuButtonSelected === 'allocate' ? 'white--text' : ''"
    >
      <v-icon
        small
        :class="menuButtonSelected === 'allocate' ? 'white--text' : ''"
      >
        mdi-pencil-outline
      </v-icon>
      配車入力
    </v-btn>
    <v-btn
      :small="$vuetify.breakpoint.smAndDown"
      height="40"
      value="daily"
      :class="menuButtonSelected === 'daily' ? 'white--text' : '' "
    >
      <v-icon
        small
        :class="menuButtonSelected === 'daily' ? 'white--text' : '' "
      >
        mdi-calendar
      </v-icon>
      配車予定(日)
    </v-btn>
    <v-btn
      :small="$vuetify.breakpoint.smAndDown"
      height="40"
      value="weekly"
      :class="menuButtonSelected === 'weekly' ? 'white--text' : '' "
    >
      <v-icon
        small
        :class="menuButtonSelected === 'weekly' ? 'white--text' : '' "
      >
        mdi-calendar
      </v-icon>
      配車予定(週)
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'AllocationSwitchButton',
  components: {},
  mixins: [],
  props: {
    currentView: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      menuButtonSelected: null
    }
  },
  computed: {},
  watch: {
    menuButtonSelected (newVal) {
      this.$emit('switchView', newVal)
    }
  },
  created() {
    this.menuButtonSelected = this.currentView
  },
  methods: {}
}
</script>

<style scoped>

</style>
